import { groupBy } from 'lodash';
import axios from 'axios';
import { types, flow, Instance } from 'mobx-state-tree';

import { getCompanyDomain } from '@src/helpers';
import * as JobsAPI from '@src/services/jobs';

export const JobBoardModel = types.model('JobBoardModel', {
  id: types.identifierNumber,
  board_id: types.maybeNull(types.integer),
  login: types.maybeNull(types.string),
  pass: types.maybeNull(types.string),
  signup_and_post: types.maybeNull(types.boolean)
});

export const JobBoardsModel = types
  .model({
    advertising: types.maybeNull(types.array(JobBoardModel))
  })
  .actions(self => {
    const CancelToken = axios.CancelToken;
    let source = CancelToken.source();

    return {
      abort: function() {
        source.cancel('Operation canceled by the user.');
        source = CancelToken.source();
      },
      getJobAdvertising: flow(function*({ jobId }) {
        self.isFetching = self.isFetching + 1;
        try {
          const companySlug = getCompanyDomain();
          const response = yield JobsAPI.getJobAdvertising({ companySlug, jobId }, { cancelToken: source.token });
          const job = self.jobs.get(jobId) || {};
          self.jobs.set(jobId, { ...job, advertising: response });
        } finally {
          self.isFetching = self.isFetching - 1;
        }
      }),
      updateJobAdvertising: flow(function*({ jobId, ...payload }) {
        const companySlug = getCompanyDomain();
        const response = yield JobsAPI.updateJobAdvertising({ companySlug, jobId, ...payload });
        const job = self.jobs.get(jobId);
        self.jobs.set(jobId, { ...job, advertising: response });
      })
    };
  })
  .views(self => ({
    get boardsByCountry() {
      return groupBy(self.boards, 'country');
    }
  }));

export type IJobBoardsModel = Instance<typeof JobBoardsModel>;
export type IJobBoardModel = Instance<typeof JobBoardModel>;
